import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Image, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { FaLinkedin,  FaWhatsapp, FaEnvelope, FaGlobe, FaPhone, FaBrain } from 'react-icons/fa';
import './careerspage.css';
import companyLogo from "../images/companylogo.jpeg";
import companyLogo1 from "../images/techlogo.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Firebase configuration - replace with your own config
const firebaseConfig = {
    apiKey: "AIzaSyAo8JAiRJUyz6ArJCHOCwEqHQEmfbWgtgA",
    authDomain: "olewin-academy.firebaseapp.com",
    projectId: "olewin-academy",
    storageBucket: "olewin-academy.appspot.com",
    messagingSenderId: "622543323365",
    appId: "1:622543323365:web:9a3e28d5c63850d60e940c",
    measurementId: "G-09WHHRMJRC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const CareersPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    jobRole: '',
    experience: '',
    jobType: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitSuccess(false);
    setSubmitError(false);

    try {
      await addDoc(collection(db, "jobApplications"), {
        ...formData,
        appliedAt: new Date()
      });
      setSubmitSuccess(true);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        jobRole: '',
        experience: '',
        jobType: ''
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      setSubmitError(true);
    }
    setSubmitting(false);
  };

  const techProjects = [
    { name: "Space Tech - Satellite - Modules", icon: "🪐", color: "#ff7700" },
    { name: "Quantum Computing", icon: "㉃", color: "#ff7700" },
    { name: "Blockchain Solutions", icon: "💻", color: "#ff7700" },
    { name: "AI & Machine Learning", icon: <FaBrain/>, color: "#4e46e5" },
    { name: "Quantum Applications", icon: "⚛️", color: "#38b2ac" },
    { name: "Full Stack Web Apps", icon: "🌐", color: "#805ad5" },
    { name: "Mobile Applications", icon: "📱", color: "#dd6b20" },
    { name: "Energy Sector Solutions", icon: "⚡", color: "#38a169" }
  ];

  return (
    <Container fluid className="careers-page p-0">
      {/* Hero Section */}
      <motion.div 
        className="hero-section text-center my-5 py-5 mb-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Container>

            {/*  adding  images here  */}

            <Image src={companyLogo1} alt="OleWinTechSolutions Logo" className="company-logo img-fluid mb-3" />

          <motion.h1 
            className="fs-5 fw-bold mb-4"
            initial={{ y: -50 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 100 }}
          >
            Careers at OlewinTech Solutions
          </motion.h1>
          <motion.p 
            className="lead mb-4"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            Join our team of innovators and shape the future of technology
          </motion.p>
            
        </Container>
      </motion.div>

      {/* Tech Projects Section */}
      <section className="tech-projects py-5 bg-light">
        <Container>
          <motion.h2 
            className="text-center mb-5"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Our Cutting-Edge Projects
          </motion.h2>
          <Row className="g-4">
            {techProjects.map((project, index) => (
              <Col md={4} sm={6} key={index}>
                <motion.div
                  initial={{ y: 50, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                >
                  <Card className="h-100 project-card border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="project-icon mb-3" style={{ backgroundColor: project.color }}>
                        <span>{project.icon}</span>
                      </div>
                      <Card.Title className="fw-bold">{project.name}</Card.Title>
                      <Card.Text>
                        Leading the innovation in {project.name.toLowerCase()} with our world-class research and development team.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Selection Process */}
      <section className="selection-process py-5">
        <Container>
          <motion.h2 
            className="text-center mb-5"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Our Selection Process
          </motion.h2>
          <Row className="justify-content-center">
            <Col lg={8}>
              <motion.div
                className="process-timeline"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
              >
                <div className="timeline-item">
                  <div className="timeline-marker">1</div>
                  <div className="timeline-content">
                    <h4>Application Review</h4>
                    <p>Our team carefully reviews your application to match your skills with our opportunities.</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">2</div>
                  <div className="timeline-content">
                    <h4>Technical Assessment</h4>
                    <p>Complete a technical challenge related to your area of expertise.</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">3</div>
                  <div className="timeline-content">
                    <h4>Interview Rounds</h4>
                    <p>Participate in technical and cultural fit interviews with our team.</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">4</div>
                  <div className="timeline-content">
                    <h4>Offer & Onboarding</h4>
                    <p>Welcome to the OleWin Tech Solutions family! Begin your journey with us.</p>
                  </div>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Company Description */}
      <section className="company-description py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col md={4} className="text-center mb-4 mb-md-0">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Image src={companyLogo} alt="OleWinTechSolutions Logo" className="company-logo img-fluid" />
              </motion.div>
            </Col>
            <Col md={8}>
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <h2 className="mb-4">About OlewinTechSolutions</h2>
                <p className="lead">
                  Olewin Tech Solutions is a leading technology innovator at the forefront of digital transformation.
                </p>
                <p>
                  Founded with a vision to revolutionize the tech landscape, we specialize in developing cutting-edge 
                  solutions across multiple domains including AI agents, advanced LLM models, quantum computing applications, 
                  mobile app development, full-stack web applications, and innovative energy sector technologies.
                </p>
                <p>
                  Our multidisciplinary team of experts brings together diverse knowledge and skills to tackle complex 
                  challenges and create transformative solutions that drive businesses forward in the digital age.
                </p>
                <Button 
                  variant="primary" 
                  href="https://olewintechsolutions.com/" 
                  target="_blank" 
                  className="mt-3"
                >
                  Visit Our Website
                </Button>
                 <Button
      className="btn btn-white bg-success fw-bold text-center mt-3 mx-3 "
      onClick={() => navigate("/jobs")}
    >
      Open Positions
    </Button>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

     

      {/* Contact Section */}
      <section className="contact-section py-5 bg-light">
        <Container>
          <motion.h2 
            className="text-center mb-5"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Contact Us
          </motion.h2>
          <Row>
            {/* Contact Information */}
            <Col lg={5} className="mb-4 mb-lg-0">
              <motion.div
                className="contact-info p-4 bg-white rounded shadow-sm"
                initial={{ x: -50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <h3 className="mb-4">Get In Touch</h3>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <FaEnvelope className="me-2 text-primary" />
                    <a href="mailto:olewintechsolutions@gmail.com" target="_blank" rel="noreferrer" >careers@olewintechsolutions.com</a>
                  </li>
                  <li className="mb-3">
                    <FaPhone className="me-2 text-primary" />
                    <a href = {`tel:+91 8639449423`} > Call Us:-  +91 (86) 3944 9423 </a>
                  </li>
                  <li className="mb-3">
                    <FaWhatsapp className="me-2 text-primary" />
                    <a href="https://wa.me/918333880649" target="_blank" rel="noopener noreferrer">WhatsApp (Tech Company)</a>
                  </li>
                  <li className="mb-3">
                    <FaWhatsapp className="me-2 text-primary" />
                    <a href="https://wa.me/918639449423" target="_blank" rel="noopener noreferrer">WhatsApp (Academy)</a>
                  </li>
                  <li className="mb-3">
                    <FaLinkedin className="me-2 text-primary" />
                    <a href="https://www.linkedin.com/in/olewin-techsolutions-889893325/" target="_blank" rel="noopener noreferrer">LinkedIn (Tech Company)</a>
                  </li>
                  <li className="mb-3">
                    <FaLinkedin className="me-2 text-primary" />
                    <a href="https://www.linkedin.com/company/olewin-academy/" target="_blank" rel="noopener noreferrer">LinkedIn (Academy)</a>
                  </li>
                 
                  <li className="mb-3">
                    <FaGlobe className="me-2 text-primary" />
                    <a href="https://www.olewintechsolutions.com" target="_blank" rel="noopener noreferrer"> Visit Website</a>
                  </li>
                </ul>
              </motion.div>
            </Col>

            {/* Application Form */}
            <Col lg={7}>
              <motion.div
                className="application-form p-4 bg-white rounded shadow-sm"
                initial={{ x: 50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <h3 className="mb-4">Apply for Job Opportunities</h3>
                
                {submitSuccess && (
                  <Alert variant="success" className="mb-4">
                    Your application has been submitted successfully! We'll get back to you soon.
                  </Alert>
                )}
                
                {submitError && (
                  <Alert variant="danger" className="mb-4">
                    There was an error submitting your application. Please try again later.
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="fullName">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control 
                          type="text" 
                          name="fullName" 
                          value={formData.fullName} 
                          onChange={handleChange} 
                          required 
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="email">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control 
                          type="email" 
                          name="email" 
                          value={formData.email} 
                          onChange={handleChange} 
                          required 
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="phone">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control 
                          type="tel" 
                          name="phone" 
                          value={formData.phone} 
                          onChange={handleChange} 
                          required 
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="experience">
                        <Form.Label>Years of Experience</Form.Label>
                        <Form.Control 
                          type="text" 
                          min="0" 
                          name="experience" 
                          value={formData.experience} 
                          onChange={handleChange} 
                          required 
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="jobRole">
                        <Form.Label>Job Role</Form.Label>
                        <Form.Select 
                          name="jobRole" 
                          value={formData.jobRole} 
                          onChange={handleChange} 
                          required
                        >
                          <option value="">Select Job Role</option>
                          <option value="AI Engineer">AI Engineer</option>
                          <option value="Blockchain Developer">Blockchain Developer</option>
                          <option value="Quantum Computing Specialist">Quantum Computing Specialist</option>
                          <option value="Full Stack Developer">Full Stack Developer</option>
                          <option value="Mobile App Developer">Mobile App Developer</option>
                          <option value="Energy Solutions Engineer">Energy Solutions Engineer</option>
                          <option value="geotechnical">Geo-Technical Engineer</option>
                          <option value="FullGeo Application">Full Stack GEo Application Developer</option>
                          <option value="geoscientist">GeoScientist Technical</option>
                          <option value="UI/UX Designer">UI/UX Designer (AI & Quantum Apps)</option>
                          <option value="Data Scientist">Data Scientist</option>
                          <option value="Data Analyst">Data Analyst</option>
                          <option value="Project Manager">Project Manager</option>
                          <option value="others">Other Not Specified</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="jobType">
                        <Form.Label>Job Type</Form.Label>
                        <Form.Select 
                          name="jobType" 
                          value={formData.jobType} 
                          onChange={handleChange} 
                          required
                        >
                          <option value="">Select Job Type</option>
                          <option value="Full-time">Full-time</option>
                          <option value="Part-time">Part-time</option>
                          <option value="Contract">Contract</option>
                          <option value="Internship">Internship</option>
                          <option value="Remote">Remote</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
                    <Button 
                      variant="dark" 
                      type="submit" 
                      className="mx-auto whatsapp-btn w-50"
                      href="https://wa.me/918333880649"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp className="mx-auto my-2 " size={25} /> Contact via WhatsApp
                    </Button>
                    <Button 
                      variant="primary" 
                      type="submit" 
                      disabled={submitting}
                    >
                      {submitting ? 'Submitting...' : 'Submit Application'}
                    </Button>
                  </div>
                </Form>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

    </Container>
  );
};

export default CareersPage;